// extracted by mini-css-extract-plugin
export default {"fruitbasketexample":"a98e426cd6be72caa579"};